import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {
    Checkbox, Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import {SuppliersModal} from "./SuppliersModal";
import {Link} from "react-router-dom";
import ArrivalMaterialExportService from "../../../../../../API/organization/ArrivalMaterialExportService";
import {ExportingSupplyRequestsModal} from "../../../../modal/ExportingSupplyRequestsModal";

const SuppliersTable = ({
                            isModal,
                            data,
                            setData,
                            suppliers,
                            selectedString,
                            setSelectedString,
                            disabled,
                            tableOptions,
                            tableOptionsHandle,
                            handleModalAlert,
                            api,
                            admin
                        }) => {
    const initValue = {name: "", supplierMaterialCloudId: "", active: true}

    const [modalOpen, setModalOpen] = useState(false);
    const [modalExportOpen, setModalExportOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [loading, setLoading] = useState(false)

    const handleEditRow = (row) => {
        setCurrentEditRowData(row);
        setModalOpen(true)
    }
    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData(initValue)
        setModalExportOpen(false)
    }
    const handleUpdate = (data) => {
        setLoading(true)
        api.update(data, currentEditRowData.id)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                handleModalAlert("Данные изменены", 'success')
                handleClose()
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleSubmit = (values) => {
        setLoading(true)
        api.save(values).then(function (response) {
            setData(prev => [...prev, response.data])
            tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))

    };
    const handleSubmitExport = (value, supplier) => {
        setLoading(true)
        ArrivalMaterialExportService.create(supplier, value).then(function (response) {
            setData(prev => prev.map(el => response.data.supplier.id === el.id ? {
                ...el,
                tableSettings: {id: response.data.id, nameSheet: response.data.nameSheet}

            } : el))
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleDeleteRow = (row) => {
        api.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const handleDeleteRowSettings = (row) => {
        ArrivalMaterialExportService.delete(row.tableSettings.id)
            .then(function () {
                setData(prev => prev.map(el => el.tableSettings?.id === row.tableSettings.id ? {
                    ...el,
                    tableSettings: null
                } : el))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };


    const columns = useMemo(
        () => [
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                size: 510,
                grow: true,
            },
            {
                header: 'Активна',
                accessorKey: 'active',
                size: 8,
                grow: false,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.active}
                    disabled={true}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            },
            {
                id: 'tableSettings',
                header: 'Настройки прихода материалов',
                accessorFn: (row) => row?.tableSettings?.nameSheet,
                size: 250,
                grow: false,
                Cell: ({cell, row}) => (
                    <li key={cell.getValue()}>
                        <Link
                            to={'/settings/columns-arrival-material-export/' + row.original?.tableSettings?.id}>{cell.getValue()}</Link>
                    </li>
                ),
            },
        ],
        [data, setData],
    );
    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEditRow},
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
        {type: "deleteSettings", text: "Удалить настройку", handler: handleDeleteRowSettings}
    ]
    return (
        <>   {!isModal && < Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px", gap: "16px"}}>
            <Typography sx={{fontSize: "24px", fontWeight: 1100}}>Поставщики</Typography>
            <Box sx={{display: 'flex', gap: "10px"}}>
                <ButtonCreate
                    text={"Создать поставщика"}
                    width={230}
                    onClick={() => setModalOpen(true)}
                />
                <ButtonCreate
                    text={"Добавить настройку поставщику"}
                    width={300}
                    onClick={() => setModalExportOpen(true)}
                />
            </Box>
        </Box>}
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTablePaperProps={{
                    sx: disabled && {
                        opacity: 0.7
                    }
                }}
                muiTableContainerProps={{
                    sx: {
                        width: '1100px',
                        maxHeight: `calc(100vh - 420px)`
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "&:second-of-type": !isModal && {
                            padding: 0,
                            width: 'calc(100% - 1px)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                        "&:first-of-type": !isModal && {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        onClick: () => isModal && !disabled && setSelectedString(row.original),
                        sx: () => ({
                            height: '36px',
                            cursor: isModal && "pointer",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                            },
                            backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                            "&:hover": {
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                columns={columns}
                data={data || []}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        disabled={!row.original.tableSettings?.id && el.type === "deleteSettings"}
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                initialState={{
                    sorting: [{id: 'name', desc: false}],
                    columnVisibility: {
                        id: false,
                        active: !isModal,
                        tableSettings: !isModal,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                    columnPinning: {left: ['number']}
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                rowCount={tableOptions.totalElements}
                localization={MRT_Localization_RU}
                enableToolbarInternalActions={false}
                enableRowActions={!isModal}
                enableColumnActions={false}
                getRowId={(originalRow) => originalRow.id}
            />
            <SuppliersModal
                columns={columns}
                open={modalOpen}
                onClose={handleClose}
                initValue={currentEditRowData}
                title={currentEditRowData.id ? "Изменить поставщика" : "Добавить поставщика"}
                onSubmit={currentEditRowData.id ? handleUpdate : handleSubmit}
                suppliers={suppliers}
                handleModalAlert={handleModalAlert}
                admin={admin}
                loading={loading}
            />
            <ExportingSupplyRequestsModal
                columns={columns}
                open={modalExportOpen}
                onClose={handleClose}
                initValue={currentEditRowData}
                title={"Добавить настройки прихода материалов"}
                onSubmit={handleSubmitExport}
                suppliers={suppliers}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
        </>
    );
};

export default SuppliersTable;